import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Stages = ({ listStages, listStagesAudit }) => {
    return (
        <div className="otpBank-stages">
            <FullWrapper caseName="otpBank-stagesCase">
                <div className="otpBank-stagesWrapper">
                    <div className="otpBank-stagesContainer">
                        <div className="otpBank-stagesTitle">Этапы работы</div>
                        {listStages.map((item, index) => (
                            <div className="otpBank-stagesList" key={index}>
                                <div className="otpBank-stagesListNumber">{item.number}</div>
                                <div
                                    className="otpBank-stagesListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="otpBank-stagesWrapper">
                    <div className="otpBank-stagesContainer">
                        <div className="otpBank-stagesSubtitle">Технический аудит</div>
                        <div className="otpBank-stagesText">
                            Работы над сайтом ОТП Банка начали в&nbsp;июле 2021 года
                            с&nbsp;первичного технического аудита, который выявил следующие основные
                            проблемы:
                        </div>
                        {listStagesAudit.map((item, index) => (
                            <div className="otpBank-stagesList" key={index}>
                                <div className="otpBank-stagesListCircle" />
                                <div
                                    className="otpBank-stagesListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Stages;
